import { useEffect, useState } from "react";
import { showFullDate } from "../../Helpers/Utils";
import { FiBarChart2 } from "react-icons/fi";
import Modal from "../../Helpers/Components/Modal";

const DashboardCalendar = ({ filter, setFilter }) => {
    const [selectedRange, setSelectedRange] = useState("week");
    const [showCalendar, setShowCalendar] = useState(false);

    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");

    const [appliedRange, setAppliedRange] = useState("");
    const calendarOptions = ["today", "week", "month", "custom",]

    const formatDateTimeLocal = (date) => {
        if (!date) return "";

        const d = new Date(date);

        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");

        return `${year}-${month}-${day}T${hours}:${minutes}`;
    };

    const getTodayRange = () => {
        const now = new Date();

        const start = new Date(now);
        start.setHours(0, 0, 0, 0);

        const end = new Date(now);
        end.setHours(23, 59, 59, 999);

        return { start, end };
    };

    const getWeekRange = () => {
        const now = new Date();

        const start = new Date(now);
        const day = start.getDay();

        const diff = day === 0 ? -6 : 1 - day;

        start.setDate(start.getDate() + diff);
        start.setHours(0, 0, 0, 0);

        const end = new Date(start);
        end.setDate(end.getDate() + 6);
        end.setHours(23, 59, 59, 999);

        return { start, end };
    };

    const getMonthRange = () => {
        const now = new Date();
        return {
            start: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0),
            end: new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999),
        };
    };

    const getYearRange = () => {
        const now = new Date();

        return {
            start: new Date(now.getFullYear(), 0, 1),
            end: new Date(now.getFullYear(), 11, 31, 23, 59, 59, 999),
        };
    };

    const handleRange = (range) => {
        setSelectedRange(range);

        if (range === "custom") {
            setShowCalendar(true);
            return;
        }

        let dateRange;

        switch (range) {
            case "today":
                dateRange = getTodayRange();
                break;

            case "week":
                dateRange = getWeekRange();
                break;

            case "month":
                dateRange = getMonthRange();
                break;

            default:
                return;
        }

        setShowCalendar(false);

        setStartDate(dateRange.start);
        setEndDate(dateRange.end);

        setAppliedRange(
            `${showFullDate(dateRange.start)} → ${showFullDate(
                dateRange.end
            )}`
        );
    };

    const applyCustomRange = () => {
        if (!startDate || !endDate) {
            alert("Please select date range");
            return;
        }

        if (new Date(startDate) > new Date(endDate)) {
            alert("Start Date cannot exceed End Date");
            return;
        }

        setAppliedRange(
            `${showFullDate(startDate)} → ${showFullDate(endDate)}`
        );

        setShowCalendar(false);
        setFilterData()
    };

    useEffect(() => {
        const { start, end } = getTodayRange();
        setStartDate(start);
        setEndDate(end);
        setAppliedRange(`${showFullDate(start)} → ${showFullDate(end)}`);
    }, []);
    const setFilterData = () => {
        const parseISTDateToUTC = (dateInput) => dateInput
        setFilter({
            startDate : parseISTDateToUTC(startDate),
            endDate : parseISTDateToUTC(endDate),
            labelType: selectedRange
        });
    }

    useEffect(() => {
        if (!startDate || !endDate) return;
        if (selectedRange !== "custom") {
            setFilterData()
        }
    }, [startDate, endDate]);

    return (
        <div className="dashboard-header">

            <div className="dashboard-title">
                <div className="dashboard-icon">
                    <FiBarChart2 />
                </div>

                <div>
                    <h3>Analytics Dashboard</h3>

                    <p>
                        <span className="live-dot"></span>
                        {appliedRange}
                    </p>
                </div>
            </div>

            <div className="date-filter-buttons">
                {calendarOptions.map((range) => (
                    <button key={range} className={selectedRange === range ? "active" : ""} onClick={() => handleRange(range)} >
                        {range === "today" ? "Today" : range === "week" ? "This Week" : range === "month" ? "This Month" : "Custom"}
                    </button>
                ))}
            </div>

            {/* <div className="dashboard-actions">
                            <button
                                className="action-btn"
                                onClick={exportData}
                            >
                                <FiDownload />
                                Export
                            </button>
                        </div> */}

            <Modal
                onShow={showCalendar}
                overlayToggle={() =>
                    setShowCalendar(false)
                }
                centered
                size="sm"
            >
                <div className="custom-range-picker">

                    <h4>Select Custom Date Range</h4>

                    <div className="picker-group">
                        <label>Start Date</label>

                        <input
                            type="datetime-local"
                            value={formatDateTimeLocal(
                                startDate
                            )}
                            onChange={(e) =>
                                setStartDate(
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div className="picker-group">
                        <label>End Date</label>

                        <input
                            type="datetime-local"
                            value={formatDateTimeLocal(
                                endDate
                            )}
                            min={formatDateTimeLocal(
                                startDate
                            )}
                            onChange={(e) =>
                                setEndDate(
                                    e.target.value
                                )
                            }
                        />
                    </div>

                    <div className="picker-actions">
                        <button
                            className="cancel-btn"
                            onClick={() => {
                                setShowCalendar(false)
                                handleRange("today")
                            }
                            }
                        >
                            Cancel
                        </button>

                        <button className="apply-btn" onClick={applyCustomRange} >
                            Apply Range
                        </button>
                    </div>
                </div>
            </Modal>
        </div>
    )
}

export default DashboardCalendar;